import {
  ChangeDetectionStrategy,
  Component,
  Input,
  SimpleChange,
  ElementRef,
  ChangeDetectorRef,
  EventEmitter,
  Output,
} from "@angular/core";
import { LiveInputModel } from "../liveInput.component/liveInput.model";
import { LibraryTypes } from "../../../domain/enums";
import { MediaRepository } from "../../../domain/media-repository";
import { GraphicsInfo } from "../../../domain/graphics-info";

@Component({
  selector: "live-preview",
  templateUrl: "./livePreview.component.html",
  styleUrls: ["./livePreview.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LivePreviewComponent {
  @Input()
  isPreview: boolean = false;

  @Input()
  title: string = "Live";

  @Input()
  progressBar: number = 15.0;

  @Input()
  content: LiveInputModel = null;

  @Input()
  isMute: boolean = false;

  @Output()
  stopped: EventEmitter<boolean> = new EventEmitter();

  @Output()
  openGraphics: EventEmitter<[GraphicsInfo]> = new EventEmitter();

  urlToPlay: string = null;
  poster: string = null;
  duration = null;
  name: string = "";

  numOfSubtitles: number = 0;
  numOfAudio: number = 0;
  numOfGraphics: number = 0;

  constructor(
    private mediaRepository: MediaRepository,
    private elementRef: ElementRef,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  /**
   * Starting the compoentn
   * @retrun void
   */
  ngOnInit() {}

  /**
   * Dispatched when something need a change
   * @param newElement
   * @param oldEelement
   */
  ngOnChanges(change: SimpleChange) {
    /* Stop process if not needed */
    if (!change["content"] || change["content"].currentValue == null) {
      if (change["content"].previousValue instanceof LiveInputModel)
        this.stopVideo();

      return;
    }

    this.content = change["content"].currentValue;

    /* Parsing Content Based on Media Type => Video */
    if (this.content.type == LibraryTypes.Video) return this.parseVideo();
  }

  /**
   * Return Media Duration
   * @return {any}
   */
  getMediaForDuration() {
    if (this.content != null) return this.content.getMedia();

    return null;
  }

  /**
   * Stop the video
   * @return void
   */
  stopVideo() {
    this.name = "";
    this.poster = "";

    this.duration = "";
    this.urlToPlay = "";

    this.numOfGraphics = 0;
    this.numOfAudio = 0;
    this.numOfSubtitles = 0;
  }

  /**
   * Parsing Video Media Object
   * @return void
   */
  parseVideo() {
    /* Media Name */
    this.name =
      this.content.getMedia().name != null
        ? this.content.getMedia().name
        : this.content.getMedia().userFilename;

    /* Poster */
    this.poster = this.content.getMedia().contentSnapshotUrl;

    /* Duration */
    this.duration = this.content.getMedia().contentDuration;

    /* Getting media preview url */
    this.mediaRepository
      .getMediaPreviewUrl(this.content.getMedia().id)
      .then(
        (previewUrl) => {
          /* Assign URL and Autoplay */
          this.urlToPlay = previewUrl;
          this.changeDetectorRef.markForCheck();
        },
        (error) => {
          // console.log("ERROR", error);
        },
      )
      .catch((error) => {
        // console.log("EXCEPTION", error);
      });

    /* Loading media info */
    this.mediaRepository
      .getMediaInfo(this.content.getMedia().id)
      .then(
        (mediaInfo) => {
          /* Setup Extra needed info */
          this.setupSubtitles(mediaInfo.subtitles)
            .setupAudio(mediaInfo.audioFiles)
            .setupAttachedGraphics(this.content.getAttachedGraphic());
          this.changeDetectorRef.markForCheck();
        },
        (error) => {},
      )
      .catch((error) => {});
  }

  /**
   * Setup Subtitles (if need to show or not)
   * @return void
   */
  setupSubtitles(subtitles) {
    this.numOfSubtitles = subtitles.length;
    return this;
  }

  /**
   * Setup audio files (if capsule should be visible or not)
   * @param audioFiles
   */
  setupAudio(audioFiles) {
    this.numOfAudio = audioFiles.length;
    return this;
  }

  /**
   * Setup attached graphics
   * @param attachedGraphics
   */
  setupAttachedGraphics(attachedGraphics) {
    this.numOfGraphics = attachedGraphics.length;
    return this;
  }

  /**
   * Play Video in Live Preview Container
   *
   */
  playVideo() {
    let videoElement: HTMLVideoElement =
      this.elementRef.nativeElement.querySelector("video");

    if (this.isMute) videoElement.muted = true;

    videoElement.play();
  }

  /**
   * Firing out an event about pausing
   * @return void
   */
  videoStopped() {
    this.stopped.emit(this.isPreview);
  }

  /**
   * on attached graphic clicked
   * @param event
   */
  onAttachedGraphicClick(event) {
    if (this.numOfGraphics > 0) {
      this.openGraphics.emit(this.content.getAttachedGraphic());
    }
  }
}
